import $ from "jquery";
globalThis.$ = $;
globalThis.jQuery = $;
console.log("✅ jQuery exposed globally");